import { Directive, inject, OnDestroy, OnInit } from "@angular/core";
import { ThemeService } from "src/app/core/services/theme.service";

@Directive({
    selector: '[authTheme]',
})
export class AuthThemeDirective implements OnInit, OnDestroy {
    private themeService = inject(ThemeService)

    ngOnInit(): void {
        this.themeService.setTransientTheme();
    }

    ngOnDestroy(): void {
        this.themeService.setSavedTheme();
    }
}
